import React from 'react'
import PropTypes from 'prop-types'
import { Box, CircularProgress, Typography } from '@mui/material'
import styles from './LoadingSpinner.module.scss'

const LoadingSpinner = ({
  size = 40,
  message,
  fullPage = false,
  color
}) => {
  const spinnerColor = color || 'var(--color-brand-primary)'

  return (
    <Box
      className={`${styles.container} ${fullPage ? styles.fullPage : ''}`}
      role='status'
      aria-busy='true'
      aria-label={message || 'Loading'}
    >
      <CircularProgress
        size={size}
        style={{ color: spinnerColor }}
        aria-hidden='true'
      />
      {message && (
        <Typography
          variant='body2'
          className={styles.message}
        >
          {message}
        </Typography>
      )}
    </Box>
  )
}

LoadingSpinner.propTypes = {
  size: PropTypes.number,
  message: PropTypes.string,
  fullPage: PropTypes.bool,
  color: PropTypes.string
}

export default LoadingSpinner
